import React, {useEffect, useState} from 'react'
import ShowLink from "../../../common/ui/show-link";
import {getSingleQuote, searchQuotes} from "../../../common/services/quote-data-service";
import _ from 'lodash'
import {getSingleDesign, updateSingleDesign} from "../../services/design-data-service";
import {useParams} from "react-router-dom";
import ShowDesignDetail from "../common/show-design-detail";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {
    DEFAULT_PUBLISHER_TAB,
    DESIGN_EDITOR_TAB, PUBLISHER_TABS_LIST
} from "../../constants/design.constant";
import {
    getSingleParentProduct,
    getSingleParentProductById,
    searchParentProducts
} from "../../../pod/services/parent-product-data-service";
import {getAllTags, searchTags} from "../../../common/services/tag-data-service";
import ShowParentProductColorList from "../common/show-parent-product-color-list";
import {getSinglePod} from "../../../pod/services/pod-data-service";
import ParentProductDetail from "../../../pod/components/parent-product/edit-parent-product/parent-product-detail";
import PublisherDesignVariantList from "./publisher-design-variant-list";
import PublisherDesignVariantDetailList from "./publisher-design-variant-detail-list";
import DownloadDesignVariants from "../download/download-design-variants";
import RenderDesignVariantList from "../multi-products-designer/render-design-variant-list";
import {getAllDesignVariants} from "../../services/design-variant-data-service";
import {ArrowDownOnSquareIcon} from "@heroicons/react/24/solid";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import DesignMetaDetail from "./design-meta-detail";
import DesignSummary from "./design-summary";
import {getSinglePrintfulInfo} from "../../../printful/services/printful-info-data.service";
import {PRINTFUL_INFO_IDS} from "../../../printful/constants/printful-info.constant";
import Promise from "bluebird";

const tabsList = PUBLISHER_TABS_LIST;

const PublisherDashboard = () => {
    const {designId} = useParams();
    const [initialStep, setInitialStep] = useState(true);
    const [designDetail, setDesignDetail] = useState(null);
    const [quoteDetail, setQuoteDetail] = useState(null);
    const [parentProduct, setParentProduct] = useState(null);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_PUBLISHER_TAB);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [allTags, setAllTags] = useState([]);
    const [podDetail, setPodDetail] = useState(null);
    const [designVariantList, setDesignVariantList] = useState(null);
    const [downloadAllImages, setDownloadAllImages] = useState(false);
    const [printfulProductsPriceInfo, setPrintfulProductsPriceInfo] = useState(null);

    useEffect(() => {
        if (designId) {
            getDesignById();
            getTagsList();
        }
    }, [designId]);

    const getTagsList = async () => {
        const tagsListResult = await getAllTags();
        setAllTags(tagsListResult);
    }

    const getSelectedDesignVariantDetails = async () => {
        const designVariantListResult = await getAllDesignVariants(designId);
        setDesignVariantList(designVariantListResult);
    }

    const getDesignById = async () => {
        getSingleDesign(designId)
            .then(async response => {
                const designDetailData = _.cloneDeep(response.data());
                designDetailData.id = designDetailData.id || designId;
                setDesignDetail(designDetailData);

                await getSingleParentProductByDesignDetail(designDetailData);

                await getQuoteById(designDetailData.quoteId);
                await getPodDetailById(designDetailData.podId);

                if (designDetailData?.variants?.length > 0) {
                    setSelectedVariant(designDetailData?.variants[0]);
                    await getSelectedDesignVariantDetails();
                }
            });
    }

    const getSingleParentProductByDesignDetail = async (designDetailData) => {
        /*const searchCriteriaList = [];
        searchCriteriaList.push({field: 'podId', condition: '==', value: designDetailData?.podId});
        searchCriteriaList.push({field: 'market', condition: '==', value: designDetailData?.market});
        /!*searchCriteriaList.push({field: 'productType', condition: '==', value: designDetailData?.productType});
        searchCriteriaList.push({field: 'category', condition: '==', value: designDetailData?.category});*!/
        searchCriteriaList.push({field: 'name', condition: '==', value: designDetailData?.parent});

       const parentProductsList: any = searchParentProducts(searchCriteriaList);


        console.log('parentProductsList', parentProductsList);
    */

        const printfulProductsPriceInfoDetail = await getPrintfulProductsPriceInfo();
        const parentProductsMap = _.keyBy(_.values(printfulProductsPriceInfoDetail?.products), 'title');

        const currentParentProduct: any = await getSingleParentProductById(designDetailData.parentId);

        if (currentParentProduct) {
            currentParentProduct.profitPercentage = parentProductsMap[currentParentProduct.name]?.profitPercentage || '';
            setParentProduct(currentParentProduct);
        }
    }

    const getQuoteById = async (quoteId) => {
        getSingleQuote(quoteId)
            .then(response => {
                const quoteDetailData = _.cloneDeep(response.data());
                quoteDetailData.id = quoteDetailData.id || designDetail?.quoteId;
                setQuoteDetail(quoteDetailData);
            });
    }

    const getPodDetailById = async (podId) => {
        getSinglePod(podId)
            .then(response => {
                const podDetailData = _.cloneDeep(response.data());
                setPodDetail(podDetailData);
            });
    }

    const getPrintfulProductsPriceInfo = async () => {
        let printfulProductsPriceInfoResult = await getSinglePrintfulInfo(PRINTFUL_INFO_IDS.PRINTFUL_PRODUCTS_PRICE);
        setPrintfulProductsPriceInfo(printfulProductsPriceInfoResult);

        return printfulProductsPriceInfoResult;
    }

    const updateDesign = async (existingDesignDetail) => {
        await updateSingleDesign(existingDesignDetail);
    }

    const handleSelectedVariant = (variant) => {
        setSelectedVariant(variant);
        setSelectedTab(DESIGN_EDITOR_TAB);
    }

    const openUrls = async () => {
        const existingPodDetail = {...podDetail};
        const existingDesignDetail = {...designDetail};
        const templateUrl = existingPodDetail?.templateLink;
        const searchTemplateUrl = templateUrl + existingDesignDetail.name;
        const totalVariants = existingDesignDetail?.variants?.length || 1;

        let allUrls = _.fill(Array(totalVariants), searchTemplateUrl.trim())
        allUrls = _.compact(allUrls);

        await Promise.mapSeries(allUrls, async (url) => {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    window.open(url, '_blank');
                    resolve();
                }, 10);
            });
        });

    };

    return (
        <>
            <div className="justify-center bg-gray-200 rounded dashboard-container">

                <div className="justify-start px-8 py-4">

                    <div className="flex items-center justify-start w-full mb-4">

                        <div className="w-full">
                            <div className="flex justify-start items-center mb-8 w-full">
                                <ShowLink label="Back"
                                          url="/designs"/>

                                <div className="ml-2 text-xl text-white rounded bg-purple-600 px-2 mr-2">
                                    Publisher
                                </div>

                                {designDetail &&
                                    <>
                                        <ShowDesignDetail designDetail={designDetail}/>
                                    </>
                                }
                            </div>

                            {parentProduct &&
                                <div className="-mt-6">
                                    <ShowParentProductColorList parentProduct={parentProduct}/>
                                </div>
                            }
                        </div>

                        <div className="w-2/5 flex justify-end">

                            {selectedTab?.key === 'variant-images' &&
                                <>
                                    <div className="mx-2">
                                        <ShowProgressSpinner
                                            dataFetchInProgress={downloadAllImages}/>
                                    </div>

                                    <div className="mx-2">
                                        <button onClick={() => {
                                            setDownloadAllImages(true);
                                        }}
                                                className="button-gray py-2 px-3 flex justify-center">
                                            <div className="pr-2">
                                                <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                            </div>
                                            Download All
                                        </button>
                                    </div>
                                </>
                            }


                            <div className="mr-2">
                                <button
                                    className="button-sky py-2 px-3 flex justify-center"
                                    onClick={openUrls}>
                                    Open {podDetail?.name} Template URLs
                                </button>
                            </div>

                            <DownloadDesignVariants
                                designDetail={designDetail}
                                parentProduct={parentProduct}
                                isAssignColors={undefined}
                                isPreview={undefined}
                                isLightButton={false}
                                updateVariantColorsInDesign={undefined}
                                setDesignDetail={undefined}/>

                            <div className="flex items-center justify-center ml-2">
                                <a href={`/designs/${designDetail?.id}/design`}
                                   className="button-gray px-3 py-2">
                                    Design
                                </a>
                            </div>
                        </div>

                    </div>

                    <div className="">
                        <ShowTabsList
                            setSelectedTab={setSelectedTab}
                            selectedTab={selectedTab}
                            tabsList={tabsList}/>
                    </div>

                    {selectedTab?.key === 'design-summary' &&
                        <div className="page-container">
                            <div className="items-center justify-start w-full mt-2">
                                <DesignSummary
                                    designDetail={designDetail}
                                    parentProduct={parentProduct}
                                    quoteDetail={quoteDetail}
                                    allTags={allTags}
                                    setDesignDetail={setDesignDetail}/>
                            </div>
                        </div>
                    }

                    <div className="mt-4">

                        {selectedTab?.key === 'variants' &&
                            <div className="page-container">
                                <div className="items-center justify-start w-1/3">
                                    <PublisherDesignVariantList
                                        selectedVariant={selectedVariant}
                                        setSelectedVariant={setSelectedVariant}
                                        designDetail={designDetail}
                                        setSelectedProductColor={undefined}/>
                                </div>

                                <div className="items-center justify-start w-2/3 ml-4">
                                    <PublisherDesignVariantDetailList
                                        allTags={allTags}
                                        selectedVariant={selectedVariant}
                                        setSelectedVariant={setSelectedVariant}
                                        parentProduct={parentProduct}
                                        quoteDetail={quoteDetail}
                                        designDetail={designDetail}
                                        setDesignDetail={setDesignDetail}/>
                                </div>
                            </div>
                        }

                    </div>

                    {selectedTab?.key === 'parent-product' && parentProduct &&
                        <div className="w-full">
                            <ParentProductDetail
                                parentProduct={parentProduct}
                                setParentProduct={setParentProduct}
                                allTags={allTags}/>
                        </div>
                    }

                    {selectedTab?.key === 'variant-images' && parentProduct &&
                        <div className="w-full">
                            <RenderDesignVariantList
                                downloadAllImages={downloadAllImages}
                                setDownloadAllImages={setDownloadAllImages}
                                designVariants={designVariantList}/>
                        </div>
                    }

                    {selectedTab?.key === 'design-meta-description' && designDetail &&
                        <div className="w-full">
                            <DesignMetaDetail
                                setDesignDetail={setDesignDetail}
                                designDetail={designDetail}/>
                        </div>
                    }


                </div>

            </div>
        </>
    )
}

export default PublisherDashboard
